export function openWhatsApp(phone) {
  const phoneValue = phone?.includes('+55') ? phone : `+55${phone}`
  const whatsappLink = `https://wa.me/${phoneValue.replace(/\D+/g, '')}`
  window.open(whatsappLink, '_blank')
}

export function openWhatsAppWithMessage({ message, phone }) {
  const phoneValue = phone?.includes('+55') ? phone : `+55${phone}`

  const whatsappLink = `https://wa.me/${phoneValue.replace(/\D+/g, '')}`
  if (!message) {
    window.open(whatsappLink, '_blank')
  } else {
    const messageWa = encodeURIComponent(message)
    window.open(`${whatsappLink}?text=${messageWa}`, '_blank')
  }
}
